/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */

import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import CartaoDia from "./CartaoDia";
import Calendario from "./Calendario";

const CartaoMes = (props) => {
  const momento = moment();
  const [calendario, setCalendario] = useState();
  const diasSemana = ["D", " S", "T", "Q", "Q", "S", "S"];
  const meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  useEffect(() => {
    if (props) {
      momento.set("year", props.ano);
      momento.set("month", props.indice);
      setCalendario(Calendario(momento));
    }
  }, [momento, props]);

  return (
    <div id="cartao-mes">
      <div className="cabecalho">{meses[props.indice]}</div>
      <div className="dias-semana">
        {diasSemana.map((val, ind) => (
          <div className="dia-semana" key={ind}>
            {val}
          </div>
        ))}
      </div>
      {calendario?.map((semana) => (
        <div className="semana">
          {semana.map((dia) => (
            <CartaoDia
              key={dia._d.getTime() + props.mes}
              dia={dia}
              mes={props.mes}
              ano={props.ano}
              indice={props.indice}
              dataSelecionada={props.dataSelecionada}
              setDataSelecionada={props.setDataSelecionada}
              facultativos={props.facultativos}
              feriados={props.feriados}
              history={props.history}
              match={props.match}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default CartaoMes;
